import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import {
  CtaBanner,
  FaqAccordion,
  RewardsCalculator,
  RewardsHero,
  TestimonialGrid,
  TextSection,
} from '~/components/sections';
import { trustedBySection } from '~/content/shared';
import { pageHeadMeta } from '~/lib/seo';

export const Route = createFileRoute('/rewards')({
  head: () =>
    pageHeadMeta({
      title: 'Up to 4.2% yearly rewards — nsave',
      description:
        'Earn up to 4.2% yearly rewards on your balance. Project your growth with the rewards calculator.',
      path: '/rewards',
    }),
  component: RewardsPage,
});

function RewardsPage() {
  return (
    <PageShell>
      <RewardsHero />
      <RewardsCalculator />
      <TextSection content={trustedBySection} />
      <TestimonialGrid />
      <FaqAccordion />
      <CtaBanner />
    </PageShell>
  );
}
